import { events } from '@ddc-webplatform/cmsc-modules';
import { TRACKING_APP_NAME } from 'constants/global-constants';
import { TRACKING_EVENT } from 'constants/trackingEvents';
import { TrackingPayload } from 'models';

const EVENT_FEATURE = 'Sitemap Workflow';


export const getClickEventWithDefaults = (
	eventData: Partial<TrackingPayload> &
		Pick<TrackingPayload, 'eventElement' | 'eventResult'>
): TrackingPayload => ({
	event: 'userEvent',
	eventAction: 'clicked',
	eventFeatures: EVENT_FEATURE,
	...eventData
});

const EVENT_TYPE_MAP: Record<string, TrackingPayload> = {
	[TRACKING_EVENT.OPEN_SITEMAP_EDITOR]: getClickEventWithDefaults({
		eventElement: 'View in Sitemap button',
		eventResult: 'Entered Sitemap workflow'
	}),
	[TRACKING_EVENT.SEARCH_SITEMAP]: getClickEventWithDefaults({
		eventElement: 'Search Icon',
		eventResult: 'Search submitted'
	}),
	[TRACKING_EVENT.NAVIGATE_TO_PAGE]: getClickEventWithDefaults({
		eventElement: 'Page URL',
		eventResult: 'Navigated to page'
	}),
	[TRACKING_EVENT.CANCEL_PAGE_DETAILS]: getClickEventWithDefaults({
		eventElement: 'Cancel button',
		eventResult: 'Sitemap entry changes cancelled'
	}),
	[TRACKING_EVENT.SAVE_PAGE_DETAILS]: getClickEventWithDefaults({
		eventElement: 'Save Button',
		eventResult: 'Page details saved'
	}),
	[TRACKING_EVENT.ENTER_MANAGE_MODE]: getClickEventWithDefaults({
		eventElement: 'Managed Pages Button',
		eventResult: 'Opened batch edit options'
	}),
	[TRACKING_EVENT.DELETE_PAGES]: getClickEventWithDefaults({
		eventElement: 'Delete Button',
		eventResult: 'Pages deleted'
	}),
	[TRACKING_EVENT.EXPORT_SITEMAP_CSV]: getClickEventWithDefaults({
		eventElement: 'Export Sitemap entry',
		eventResult: 'Exported sitemap to CSV'
	}),
	[TRACKING_EVENT.SAVE_BATCH_EDIT]: getClickEventWithDefaults({
		eventElement: 'Save Button',
		eventResult: 'Batch edit saved'
	}),
	[TRACKING_EVENT.CANCEL_BATCH_EDIT]: getClickEventWithDefaults({
		eventElement: 'Cancel button',
		eventResult: 'Sitemap entry changes cancelled'
	})
};

export const getItemActionTrackingObject = (eventType: string): TrackingPayload =>
	EVENT_TYPE_MAP[eventType] ??
	getClickEventWithDefaults({
		eventElement: eventType,
		eventResult: eventType
	});

export const fireTrackableEvent = (
	eventType: string,
	overrides?: Partial<TrackingPayload>
): void => {
	const base = getItemActionTrackingObject(eventType);
	const payload = overrides ? { ...base, ...overrides } : base;
	events.fireTrackableEvent(TRACKING_APP_NAME, payload);
};
